import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';
import styles from './Home.module.css';

const pathsToAllow = [
    '/vr',
    '/auth/login',
    '/auth/signup',
    '/auth/forgot-password',
    '/auth/action',
]

const Home = ({ user }) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!user && !pathsToAllow.includes(window.location.pathname)) {
            navigate('auth/login');
        } else if (!user && window.location.pathname.includes('/vr')) {
            navigate('vr?model=gallerij_xs');
        } else if (user?.private && window.location.pathname === '/') {
            navigate('app');
        } else if (user && !user?.private && !user?.token?.claims?.email_verified && window.location.pathname !== '/auth/action') {
            navigate('auth/not-verified');
        } else if (user && !user?.private && user?.token?.claims?.email_verified) {
            navigate('auth/new-user');
        }
    }, [user, navigate])

    return (
        <div className={styles.Home} data-testid="Home">
            <Outlet />
        </div>
    )
};

export default Home;
